import { createContext, useContext } from 'react';
import type { FirmBaseLayoutContextValue } from './FirmBaseLayoutContext.types';

const noop = () => {};

const DEFAULT_FIRM_BASE_LAYOUT_CONTEXT_VALUE: FirmBaseLayoutContextValue = {
  secondaryNavigation: null,
  tertiaryNavigation: null,
  clearSecondaryNavigation: noop,
  clearSecondaryNavigationContribution: noop,
  clearTertiaryNavigation: noop,
  registerSecondaryNavigation: noop,
  registerSecondaryNavigationContribution: noop,
  registerTertiaryNavigation: noop,
};

export const FirmBaseLayoutContext = createContext<FirmBaseLayoutContextValue>(
  DEFAULT_FIRM_BASE_LAYOUT_CONTEXT_VALUE
);

FirmBaseLayoutContext.displayName = 'FirmBaseLayoutContext';

export const useFirmBaseLayoutContext = (): FirmBaseLayoutContextValue => useContext(FirmBaseLayoutContext);
